import Actions from './navigator-actions';
import sagas from './navigator-sagas';
import Selectors from './navigation-selector';

export default {
  Actions,
  namespace: 'navigator',
  sagas:     [sagas],
  Selectors,
};
